import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'

import type { Styles } from '../../theme/types/Styles'

export { StickyDeadlineIcon }

const referenceDict = {
  geplandeUitvoeringsdatum: 'geplande start uitvoering',
  startUitvoeringWeek: 'geplande start uitvoering',
} as const

type Props = {
  sx?: Styles
  herplanReference: string
}

function StickyDeadlineIcon({ sx, herplanReference }: Props) {
  if (herplanReference in referenceDict === false) {
    return null
  }

  return (
    <Tooltip
      title={`Oplevermoment beweegt mee met de ${referenceDict[herplanReference]} van het project`}
    >
      <IconButton sx={{ cursor: 'help', ...sx }}>
        <SwapHorizontalCircleIcon />
      </IconButton>
    </Tooltip>
  )
}
